import {
  GroupStatus,
  InvitationFragment,
  InvitationType
} from "../api/generated"
import { exhaustiveGuard } from "../lib/typing"
import {
  CohortInvitationRoleInt,
  INVITATION_TYPE_PERMISSION_MAP,
  MentorGroupInvitationRoleInt,
  ROLES,
  ROLE_CONFIGS,
  ROLE_DESCRIPTORS,
  ROLE_ICONS,
  ROLE_LABELS,
  ROLE_LABELS_PLURAL,
  ROLE_TYPE_OFFERING,
  SchoolInvitationRoleInt
} from "./constants"

export const getRoleOptions = (type: any, filter: any, { t, tca }: any) => {
  const withLabelAndDescriptor = (role: any) => {
    return {
      value: role,
      // @ts-expect-error
      icon: ROLE_ICONS[type]?.[role],
      // @ts-expect-error
      label: tca(ROLE_LABELS[type][role]),
      // @ts-expect-error
      label_plural: tca(ROLE_LABELS_PLURAL[type][role]),
      // @ts-expect-error
      descriptor: t(ROLE_DESCRIPTORS[type][role]),
      roleType: role
    }
  }

  // @ts-expect-error
  let roles = ROLES[type]

  if (filter) {
    roles = roles.filter((role: any) => filter(type, role))
  }

  return roles.map(withLabelAndDescriptor)
}

export const filterAvailableRoles = (type: any, role: any, group: any) => {
  switch (type) {
    case ROLE_TYPE_OFFERING:
      return group
        ? !!(
            group.status !== GroupStatus.Completed &&
            group.permissions &&
            // @ts-expect-error
            group.permissions[INVITATION_TYPE_PERMISSION_MAP[type][role]]
          )
        : true // if no group, simple allow all role options
    default:
      return true
  }
}

export function getInvitationRoleConfig(invitation: InvitationFragment) {
  switch (invitation.invitation_type) {
    case InvitationType.Cohort:
      return ROLE_CONFIGS[invitation.invitation_type].roles[
        invitation.invitation_role as CohortInvitationRoleInt
      ]
    case InvitationType.School:
      return ROLE_CONFIGS[invitation.invitation_type].roles[
        invitation.invitation_role as SchoolInvitationRoleInt
      ]
    case InvitationType.CommunityGroup:
      return ROLE_CONFIGS[invitation.invitation_type].roles[
        invitation.invitation_role as MentorGroupInvitationRoleInt
      ]
    default:
      return exhaustiveGuard(invitation.invitation_type)
  }
}
